import React from 'react';
import {
	CssBaseline
} from '@material-ui/core';

import Navigation from './Components/Navigation';

function App() {
	return (
		<React.Fragment>
			<CssBaseline />
			<Navigation />
    	</React.Fragment>
  	);
}

export default App;
